import {createFileRoute, Outlet, useLocation} from '@tanstack/react-router';
import {PATHOLOGY_CUSTOMIZATION_LIST} from '@/practitioner/routing/paths';
import {companyAdminGranted, grantUser} from '@/practitioner/routing/utils/beforeLoadUtils';

import PathologyCustomizationList from '@/practitioner/views/company/PathologyCustomization/PathologyCustomizationList';

const PathologyCustomizationLayout = () => {
  const {pathname} = useLocation();
  const isRoot = pathname === PATHOLOGY_CUSTOMIZATION_LIST;
  return isRoot ? <PathologyCustomizationList /> : <Outlet />;
};

export const Route = createFileRoute('/(practitioner)/company/pathology-customization')({
  component: PathologyCustomizationLayout,
  beforeLoad: grantUser(companyAdminGranted)
});
